import React from 'react';
import styled from 'styled-components';
import { useParams, useHistory } from 'react-router-dom';

import Tabs from 'antd/es/tabs';

import colors from 'config/colors';

import useProcessDetails from 'hooks/useProcessDetails';

import { Row, Col } from 'components/layout';
import MainLayout from 'layouts/Main.layout';
import PageHeader from 'components/PageHeader';
import Button from 'components/Button';
import StateTag from 'components/process/StatusTag';

import SummaryTab from '../tabs/Summary.tab';
import ChartsTab from '../tabs/Charts.tab';
import YmsDataTab from '../tabs/YmsData.tab';
import AlertsTab from '../tabs/Alerts.tab';
import HistoryTab from '../tabs/History.tab';
import LogsTab from '../tabs/Logs.tab';

const processDetailsTabs = [
  {
    key: 'charts',
    title: 'Stats',
    component: ChartsTab,
  },
  {
    key: 'summary',
    title: 'Details',
    component: SummaryTab,
  },
  {
    key: 'yms',
    title: 'Yms Data',
    component: YmsDataTab,
  },
  {
    key: 'alerts',
    title: 'Alerts',
    component: AlertsTab,
  },
  {
    key: 'history',
    title: 'History',
    component: HistoryTab,
  },
  {
    key: 'logs',
    title: 'Logs',
    component: LogsTab,
  }
];

const ProcessDetails = () => {
  const params = useParams();
  const navigationHistory = useHistory();
  const {
    isLoading,
    processDetails,
    process,
    timeline,
  } = useProcessDetails(params.id, true);

  const {
    alerts = [],
    device_log = [],
    history = [],
    yms = [],
    // split_shifts = [],
  } = processDetails.state.stats;

  return (
    <MainLayout>
      <PageHeader
        title={`${params[0] === 'containers' ? 'Container' : 'Trailer'} ${params.id}`}
        backIcon={
          <Button shape="circle" size="large" icon={{ name: "arrow-left", color: colors.grey.lightDark, size: 18 }} />
        }
        tags={
          process ? <StateTag container={process} /> : null
        }
        onBack={() => {
          navigationHistory.goBack();
        }}
      />
      <Row style={{ padding: '24px 24px 0 24px', height: 'calc(100% - 84px)' }}>
        <Col span={24}>
          <ProcessDetailsTabs>
            {processDetailsTabs.map(({ key, title, component: Component }) => (
              <Tabs.TabPane key={key} tab={title} forceRender={true}>
                <Component
                  isLoading={isLoading}
                  equipmentType={params[0]}
                  process={process}
                  timeline={timeline}
                  alerts={alerts}
                  history={history}
                  logs={device_log}
                  yms={yms}
                />
              </Tabs.TabPane>
            ))}
          </ProcessDetailsTabs>
        </Col>
      </Row>
      
    </MainLayout>
  );
};

const ProcessDetailsTabs = styled(Tabs)`
  background-color: #fff;
  height: 100%;

  & .ant-tabs-tab {
    padding: 16px;
    margin: 0 16px 0 0;
    font-size: 15px;
  }

  & .ant-tabs-nav {
    margin-bottom: 24px;
  }

  & .ant-tabs-content-holder {
    padding: 24px;
  }
`;

export default ProcessDetails;
